import { SortingFn, SortingState } from '@tanstack/react-table';
import { compareIsoDates, formatCodeName } from '../common/utils';
import { getConfidentialDataObjectValue } from '../dataobject/ConfidentialDataObjectFormSelect';
import { ConfidentialDataObjectType } from '../dataobject/schema/formData/types';
import { getUserViewPermissionTypeName } from './UserViewPermissionTypeName';
import { UserViewPermissionFormDataType } from './schema/formData/types';

type ViewPermissionSortingFn = SortingFn<UserViewPermissionFormDataType>;

export const USER_VIEW_PERMISSION_DEFAULT_SORT: SortingState = [
  { id: 'id', desc: false },
];

export const getUserViewPermissionType = (id: string) =>
  id?.split('-').shift() ?? '';

export const getConfidentialDataObjectLabel = (
  confidentialDataObjects: ConfidentialDataObjectType[] | undefined,
  id: string,
) =>
  formatCodeName(
    confidentialDataObjects?.find(
      (dataObject) => getConfidentialDataObjectValue(dataObject) === id,
    ),
  );

export const sortViewPermissionsByType: ViewPermissionSortingFn = (a, b) =>
  getUserViewPermissionTypeName(
    getUserViewPermissionType(a.original.id),
  ).localeCompare(
    getUserViewPermissionTypeName(getUserViewPermissionType(b.original.id)),
  );

export const sortViewPermissionsByValidPeriod: ViewPermissionSortingFn = (
  a,
  b,
) => compareIsoDates(a.original.validPeriod?.[0], b.original.validPeriod?.[0]);

export const getSortViewPermissionsByDataObject =
  (
    confidentialDataObjects: ConfidentialDataObjectType[] | undefined,
  ): ViewPermissionSortingFn =>
  (a, b) =>
    getConfidentialDataObjectLabel(
      confidentialDataObjects,
      a.original.id,
    ).localeCompare(
      getConfidentialDataObjectLabel(confidentialDataObjects, b.original.id),
    );
